import { render, staticRenderFns } from "./ReviewsTableDashboardGHL.vue?vue&type=template&id=b096d888"
import script from "./ReviewsTableDashboardGHL.vue?vue&type=script&lang=js"
export * from "./ReviewsTableDashboardGHL.vue?vue&type=script&lang=js"
import style0 from "./ReviewsTableDashboardGHL.vue?vue&type=style&index=0&id=b096d888&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports